import { settingBucket } from './helpers'

const createListData = (data) => {
  const list = {}
  let total = 0
  data.forEach((hit) => {
    if ((!Object.hasOwn(list, hit.env))) {
      list[hit.env] = 1
    } else {
      list[hit.env] += 1
    }
    total++
  })
  list.totalHits = total
  return list
}

const createPieData = (data) => {
  delete data.totalHits
  const DataList = Object.keys(data).map((key) => {
    // console.log(key)
    return {
      name: key,
      value: data[key]
    }
  })
  return DataList
}

const filterData = (data, input) => {
  const bucket = settingBucket(input)
  data.forEach((hit) => {
    // Graphing data
    let found = false
    let count = 0
    while (!found && count < bucket.length) {
      if (hit.ts > bucket[count].sob && hit.ts < bucket[count].eob) {
        found = true
        bucket[count].hits += 1
        if (!Object.hasOwn(bucket[count], hit.env)) {
          bucket[count][hit.env] = 1
        } else {
          bucket[count][hit.env]++
        }
      } else {
        count++
      }
    }
  })
  // bucket.push(list)
  return bucket
}
// eslint-disable-next-line
export default {
  filterData,
  createPieData,
  createListData
}
